import React from 'react';
import PropTypes from 'prop-types';

import {
  Upload03Icon,
  CheckmarkCircleFillIcon,
  CloseCircleBoldIcon,
  CircularProgress,
} from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

export default function DeploymentStatusCell({ status }) {
  const { Icon, IconProps, tooltip, testId } = determineIconAndTooltip(status);

  return (
    <WithTooltip show title={tooltip}>
      <Icon {...IconProps} data-test-id={testId} />
    </WithTooltip>
  );
}

DeploymentStatusCell.propTypes = {
  status: PropTypes.oneOf(['idle', 'deploying', 'success', 'error']).isRequired,
};

function determineIconAndTooltip(status) {
  switch (status) {
    case 'idle':
      return {
        Icon: Upload03Icon,
        IconProps: {
          color: 'disabled',
        },
        tooltip: 'Ready to deploy',
        testId: 'deploymentIdleIcon',
      };
    case 'deploying':
      return {
        Icon: CircularProgress,
        IconProps: {
          color: 'info',
          size: '1rem',
        },
        tooltip: 'Deploying',
        testId: 'deploymentDeployingIcon',
      };
    case 'success':
      return {
        Icon: CheckmarkCircleFillIcon,
        IconProps: {
          color: 'success',
        },
        tooltip: 'Deployed',
        testId: 'deploymentSuccessIcon',
      };
    case 'error':
      return {
        Icon: CloseCircleBoldIcon,
        IconProps: {
          color: 'error',
        },
        tooltip: 'Deployment failed',
        testId: 'deploymentErrorIcon',
      };
    default:
      throw new Error(`Unknown status: ${status}`);
  }
}
